export default __webpack_public_path__ + "static/media/1000px-Washington.1afda9df.png";